import { PureComponent, HTMLProps } from 'react';
import Partial from '~/ui/react/ui-elements/Partial';
import Picture, {IProps as IPictureProps} from '~/ui/react/components/Picture';

class ProjectPreview extends PureComponent<IProps, any> {

    /**
     * @inheritDoc
     */
    public render() {
        const { props } = this;

        return <Partial endpoint={props.endpoint}>
            <div className="comp-media -ratio4x3 -rounded">
                <div className="body">
                    <Picture src={props.src} lqp={props.lqp} className="-fit-cover" />
                </div>
            </div>
        </Partial>;
    }
}

interface IProps extends HTMLProps<ProjectPreview> {
    endpoint: string;
    src: IPictureProps['src'];
    lqp: IPictureProps['lqp'];
}

export default ProjectPreview;
